module.exports = __webpack_public_path__ + "media/images/icon-ellipsis-80e11887639ff98a39a664c9d41e4cf4.svg";